import { MEMBERSHIP_BENEFITS_CONTENT } from '../constants/membershipBenefitsContent'

const MembershipBenefitsWelcomePack = () => {
  const c = MEMBERSHIP_BENEFITS_CONTENT

  return (
    <div className="text-black">
      <header className="text-center space-y-4 sm:space-y-5 mb-12 sm:mb-16 max-w-2xl mx-auto">
        <p className="font-AXONALLPrimeSemiBold text-2xl sm:text-3xl md:text-[2.125rem] uppercase tracking-tight text-black leading-tight">
          {c.brand}
        </p>
        <p className="font-poppinsRegular italic text-base sm:text-lg text-neutral-700">{c.subtitle}</p>
        <p className="font-poppinsLight text-[15px] sm:text-base leading-relaxed text-neutral-700 text-left sm:text-center pt-2">
          {c.intro}
        </p>
      </header>

      <div className="divide-y divide-black/10 border-t border-b border-black/10">
        {c.benefits.map((item) => (
          <section key={item.title} className="py-8 sm:py-10 first:pt-0 last:pb-0">
            <h3 className="font-AXONALLPrimeSemiBold text-base sm:text-lg text-black tracking-tight mb-3">
              {item.title}
            </h3>
            <p className="font-poppinsLight text-[15px] sm:text-base leading-relaxed text-neutral-700 max-w-none">
              {item.text}
            </p>
          </section>
        ))}
      </div>

      <footer className="mt-12 sm:mt-16 pt-10 border-t border-black text-center max-w-2xl mx-auto">
        <p className="font-poppinsLight text-[15px] sm:text-base leading-relaxed text-neutral-700 italic">
          {c.closing}
        </p>
      </footer>
    </div>
  )
}

export default MembershipBenefitsWelcomePack
